import { Bell, Building2, CreditCard, Settings as SettingsIcon, Sliders } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AlertsSection } from './alerts-section';
import { CompanySection } from './company-section';
import { PlanSection } from './plan-section';
import { PreferencesSection } from './preferences-section';

export function SettingsPage() {
  return (
    <div className="page">
      <header className="space-y-1.5">
        <div className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <SettingsIcon className="size-3.5" /> Sistema
        </div>
        <h1 className="text-3xl font-semibold tracking-tight">Configurações</h1>
        <p className="text-sm text-muted-foreground">
          Dados da empresa, plano, alertas e preferências.
        </p>
      </header>

      <Tabs defaultValue="company">
        <TabsList>
          <TabsTrigger value="company">
            <Building2 className="size-4" />
            Empresa
          </TabsTrigger>
          <TabsTrigger value="plan">
            <CreditCard className="size-4" />
            Cobrança & Uso
          </TabsTrigger>
          <TabsTrigger value="alerts">
            <Bell className="size-4" />
            Alertas
          </TabsTrigger>
          <TabsTrigger value="preferences">
            <Sliders className="size-4" />
            Preferências
          </TabsTrigger>
        </TabsList>

        <TabsContent value="company">
          <CompanySection />
        </TabsContent>
        <TabsContent value="plan">
          <PlanSection />
        </TabsContent>
        <TabsContent value="alerts">
          <AlertsSection />
        </TabsContent>
        <TabsContent value="preferences">
          <PreferencesSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
